import { useState, useEffect } from 'react';

interface viewportDimension {
  height: number;
  width: number;
}

/*
 * We use clientWidth/clientHeight instead of innerWidth/innerHeight because:
 * - clientWidth/Height gives us the viewport size excluding scrollbars
 * - it represents the actual visible area available for content
 * - it's more consistent across browsers for responsive design
 * - it matches how CSS viewport units (vh/vw) behave
 */
export const getViewportHeightFromDOM = (): number => {
  return typeof window === 'undefined'
    ? 0
    : document.documentElement.clientHeight;
};
export const getViewportWidthFromDOM = (): number => {
  return typeof window === 'undefined'
    ? 0
    : document.documentElement.clientWidth;
};
const useViewportDimensions = (): viewportDimension => {
  const [dimensions, setDimensions] = useState({
    height: getViewportHeightFromDOM(),
    width: getViewportWidthFromDOM(),
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: getViewportHeightFromDOM(),
        width: getViewportWidthFromDOM(),
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
};

export default useViewportDimensions;
